import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {AvisoLegalComponent} from "@app/pages/aviso-legal/aviso-legal.component";
import {CookiesPolicyComponent} from "@app/pages/cookie-policy/cookie-policy.component";
import {LandingCalculadoraComponent} from "@app/pages/landing-calculadora/landing-calculadora.component";
import {PrivacyPolicyComponent} from "@app/pages/privacy-policy/privacy-policy.component";
import {TermsComponent} from "@app/pages/terms/terms.component";
import {SharedModule} from "@shared/shared.module";
import {TranslateModule} from "@ngx-translate/core";


@NgModule({
  declarations: [
    AvisoLegalComponent,
    CookiesPolicyComponent,
    LandingCalculadoraComponent,
    PrivacyPolicyComponent,
    TermsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule
  ]
})
export class PagesModule { }
